import React from "react";
import styled from "styled-components";

const Input = styled.input.attrs(props => ({
  type: "text",
  size: props.small ? 5 : undefined
}))`
  height: 35px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;
  width:100%;
  font-size:18px;
  margin-left:3px;
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 35px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
`;
const FilterComponent = ({ filterText, onFilter, onClear,exportCSV,callbackExport }) => (
  <>
    <Input
      id="search"
      type="text"
      placeholder="Search..."
      value={filterText}
      onChange={onFilter}
    />
    <ClearButton onClick={onClear}>×</ClearButton>
  </>
);

export default FilterComponent;
